import React from "react";
import PhilosophyCanvasAnim from "./PhilosophyCanvasAnim";

import PassionProductAnim from "./PassionProductAnim";

const Banner = ({ children, theme, ...props }) => {
  let animationElement;
  switch (theme) {
    case "philosophy":
      animationElement = <PhilosophyCanvasAnim />;
      break;
    case "passion":
      animationElement = <PassionProductAnim />;
  }

  return (
    <section className="container mx-auto relative" {...props}>
      {animationElement}
      <div className="py-20 px-5">{children}</div>
    </section>
  );
};

// Header sub-component
const HeaderBoldOverride = ({ children }, key) => (
  <b className="text-primary" key={key}>
    {children}
  </b>
);

// Header sub-component
const UnderlineOverride = ({ children }, key) => (
  <b
    className="text-primary border-b-2 border-black px-3 md:px-1 sm:px-0"
    key={key}
  >
    {children}
  </b>
);

const headerTypeOverrides = {
  b: HeaderBoldOverride,
  ul: UnderlineOverride,
};

const Header = props => {
  // Apply overrides
  const processedChildren = props.children.map((child, i) => {
    return child.type && headerTypeOverrides[child.type]
      ? headerTypeOverrides[child.type](child.props, i)
      : child;
  });
  return (
    <div className="text-3xl font-bold text-center py-2">
      {processedChildren.map(child => child)}
    </div>
  );
};
Banner.Header = Header;

const Hero = props => {
  // Apply overrides
  const processedChildren = props.children.map((child, i) => {
    return child.type && headerTypeOverrides[child.type]
      ? headerTypeOverrides[child.type](child.props, i)
      : child;
  });
  return (
    <div className="text-4xl sm:text-5xl lg:text-6xl font-bold text-left leading-snug md:leading-snug lg:leading-snug">
      {processedChildren.map(child => child)}
    </div>
  );
};
Banner.Hero = Hero;

// Body sub-component
const Body = props => (
  <div className="text-base text-center py-2">{props.children}</div>
);
Banner.Body = Body;

export default Banner;
